import { ReactElement } from "react";
import {
  IContentAreaProps,
  IDataContext, IIndicator,
  IMenuButton,
  ISelectedNode,
  IViewController,
  SchemaNodeType
} from "../../types";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import MsRmReport from "./ms-rm";

class Module implements IViewController {

  private msRmQaButton: IMenuButton = {
    title: "MS - RM Report",
    icon: <FormatListBulletedIcon/>,
    color: "blue",
    dataContext: {
      title: "Charts",
      module: "qa",
      subModule: "reports/ms-rm-qa"
    }
  };

  private buttons = [
    this.msRmQaButton
  ];

  getModuleName(): string{
    return "qa";
  }

  getView (dataContext: IDataContext, props: IContentAreaProps): ReactElement {
    if (dataContext.subModule === "reports/ms-rm-qa") {
      return <MsRmReport parentSize={props.parentSize} />;
    }

    return <div />;
  }

  getButtons(node: ISelectedNode): IMenuButton[] {
    return node.type === SchemaNodeType.Area ? [this.msRmQaButton] : [];
  }

  getButton(subModule: string): IMenuButton | undefined {
    return this.buttons.find(x => x.dataContext && x.dataContext.subModule === subModule);
  }

  getIndicator(dataContext: IIndicator): ReactElement | undefined {
    if (dataContext.component === "") {
      return <div />;
    }

    return undefined;
  }
}

const instance = new Module();

export default instance;
